import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesIdsMain } from './modules/ui/Main';

const IdsPage = (
  <SuspensePage>
    <PagesIdsMain />
  </SuspensePage>
);

export default IdsPage;
